// extracted by mini-css-extract-plugin
export default {"isTyping":"IsTyping_isTyping--MPb"};